import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['content', 'upIcon', 'downIcon'];

    toggle() {
        if (this.hasContentTarget) {
            this.contentTarget.classList.toggle('hidden');
        }

        if (
            this.hasUpIconTarget &&
            this.hasDownIconTarget &&
            this.upIconTarget.classList.contains('hidden')
        ) {
            this.upIconTarget.classList.remove('hidden');
            this.downIconTarget.classList.add('hidden');
        } else {
            this.upIconTarget.classList.add('hidden');
            this.downIconTarget.classList.remove('hidden');
        }
    }
}
